export default () => ({
  notifications: []
});